import { CarHireDepot } from '@sabstravtech/obtservices/base';

export class DepotLocations {
  chosenDropoffDepot = -1;
  chosenPickupDepot = -1;
  dropoffLoading = false;
  filteredDropoffDepots: CarHireDepot[] = [];
  filteredPickupDepots: CarHireDepot[] = [];
  hasDropoffResults = false;
  hasPickupResults = false;
  pickupLoading = false;
}
